import { httpPost, httpGet } from './utils';

const api = {
  fetchList: (url, body) => httpPost(url, body),
  fetchGetList: (url) => httpGet(url),
  create: (url, body) => httpPost(url, body),
  markAsError: (url, body) => httpPost(url, body),
};

export default api;
